import React from 'react';
import {Button, Intent, Menu, MenuItem, MenuDivider, Position} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {Popover2} from '@blueprintjs/popover2';

type Callback = (value?: any) => void;

interface ContentToolbarActionsProps {
  contentId: string | number;
  disabled: boolean;
  showSave: boolean;
  showDelete: boolean;
  showDuplicate: boolean;
  onSave?: Callback | null;
  onDelete?: Callback | null;
  onDuplicate?: Callback;
}

const ToolbarActionsMenu = ({
  contentId,
  disabled,
  showSave,
  showDelete,
  showDuplicate,
  onSave,
  onDelete,
  onDuplicate,
}: ContentToolbarActionsProps) => {
  const showDivider: boolean = showDuplicate || showSave;
  /*
   * Right side action menu
   */
  return (
    <Menu>
      {
        showDuplicate && (
          <MenuItem
            icon={IconNames.DUPLICATE}
            text="Duplicate"
            onClick={onDuplicate}
            disabled={disabled}
          />
        )
      }
      {
        showSave && (
          <MenuItem
            icon={IconNames.FLOPPY_DISK}
            text="Save Block"
            onClick={onSave as any}
            disabled={disabled}
          />
        )
      }
      {
        showDelete && (
          <>
            {showDivider && <MenuDivider/>}
            <MenuItem
              icon={IconNames.TRASH}
              text="Remove"
              intent={Intent.DANGER}
              onClick={onDelete as any}
              disabled={disabled}
            />
          </>
        )
      }
    </Menu>
  );
};

export const ContentToolbarActions = ({
  contentId,
  disabled,
  showSave,
  showDelete,
  showDuplicate,
  onSave,
  onDelete,
  onDuplicate,
}: ContentToolbarActionsProps) => {
  const showActions: boolean = showSave || showDelete;

  if (!showActions) {
    return null;
  }

  return (
    <Popover2
      content={
        <ToolbarActionsMenu
          contentId={contentId}
          disabled={disabled}
          showSave={showSave}
          showDelete={showDelete}
          showDuplicate={showDuplicate}
          onSave={onSave}
          onDelete={onDelete}
          onDuplicate={onDuplicate}
        />
      }
      position={Position.BOTTOM}
    >
      <Button
        minimal={true}
        small={true}
        icon={IconNames.MORE}
      />
    </Popover2>
  );
};

export default ContentToolbarActions;
